import { Table } from "antd";
import React from "react";
import { bronData } from "../Form/formData";
import AddModal from "../Modal";

function Brony() {
  const columns = [
    {
      title: "#",
      dataIndex: "key",
    },

    {
      title: "Data",
      dataIndex: "data",
    },
    {
      title: "Klient",
      dataIndex: "klient",
    },
    {
      title: "Sklad",
      dataIndex: "sklad",
    },
    {
      title: "Kol-ov komplektov",
      dataIndex: "kol-ov_komplektov",
    },
    {
      title: "Kol-ov madelov",
      dataIndex: "kol-ov_madelov",
    },
    {
      title: "Kommentarii",
      dataIndex: "kommentarii",
    },
  ];
  return (
    <>
      <AddModal
        title={"Бронъ"}
        stil={'stil'}
        width={1400}
        form={bronData}
        columnsAll={bronData[0].columns}
        columnsAll2={bronData[0].columns1}
        button={true}
      />
      <div className="mt-2">
        <Table columns={columns} />
      </div>
    </>
  );
}

export default Brony;
